<template>
	<v-container>
		<v-row v-if="selectedItems.length > 0"
			   class="d-flex align-center rounded-lg"
			   :style="{ background: elementBackgroundColor }">
			<v-col cols="6" class="start">
				<span :style="{ color: elementTextColor }" class="element">
					{{ selectedItems.length }} item(s) selected
				</span>
			</v-col>
			<v-col cols="6" class="end delete">
				<v-btn @click="deleteSelection(selectedItems)"
					   prepend-icon="mdi-delete"
					   variant="outlined"
					   :style="{ color: elementTextColor }"
					   class="delete">DELETE</v-btn>
			</v-col>
		</v-row>
		<v-row justify="start">
			<v-col>
				<v-data-table :headers="headers"
							  :items="protocolslist"
							  :sort-by="[{ key: 'name', order: 'asc' }]"
							  :items-per-page="15"
							  :items-per-page-options="[
						{ value: 15, title: '15' },
						{ value: 30, title: '30' },
						{ value: 50, title: '50' },
						{ value: 100, title: '100' },
						{ value: 200, title: '200' },
					]"
							  loading-text="Loading... Please wait"
							  :multi-sort="true"
							  :hover="true"
							  :show-select="shouldShowSelect"
							  v-model="selectedItems">
					<template v-slot:top>
						<div class="d-flex align-center">
							<span class="font-weight-medium">Protocols</span>
							<v-spacer></v-spacer>
							<v-dialog v-model="dialog" max-width="75%">
								<template v-slot:activator="{ props }">
									<v-btn variant="outlined" v-bind="props">New Protocol</v-btn>
								</template>
								<v-card>
									<v-card-title>
										<span class="font-weight-bold">{{ itemTitle }}</span>
									</v-card-title>
									<v-card-text>
										<v-container>
											<input type="hidden" v-model="editItem.id" />
											<v-text-field class="w-auto"
														  variant="outlined"
														  v-model="editItem.name"
														  label="Name"></v-text-field>
											<v-autocomplete class="w-auto"
															variant="outlined"
															:items="getProtocolType()"
															v-model="editItem.typeName"
															label="Type"></v-autocomplete>
											<v-btn variant="outlined"
												   @click="funEditMessage(editItem.jsonConfig)">EDIT TYPE</v-btn>
										</v-container>
									</v-card-text>
									<v-divider class="mt-5"></v-divider>
									<v-card-actions>
										<v-spacer></v-spacer>
										<v-btn variant="text" @click="close">Cancel</v-btn>
										<v-btn color="primary"
											   variant="text"
											   @click="funSaveItem"
											   :loading="loading">Save</v-btn>
									</v-card-actions>
								</v-card>
							</v-dialog>

							<v-dialog v-model="editDialog" max-width="90%" max-height="90vh">
								<v-card>
									<v-card-title class="d-flex align-center">
										<span class="font-weight-bold">EDIT TYPE</span>
										<v-spacer></v-spacer>
										<v-chip :color="isValidJson(editItem.jsonConfig) ? 'success' : 'error'"
												size="small">
											{{ isValidJson(editItem.jsonConfig) ? 'Valid JSON' : 'Invalid JSON' }}
										</v-chip>
									</v-card-title>
									<v-card-text style="padding: 0;">
										<JsonEditor v-model="editItem.jsonConfig"
													:height="editorHeight" />
									</v-card-text>
									<v-divider></v-divider>
									<div class="button-container">
										<v-card-actions>
											<input type="file"
												   ref="fileInput"
												   @change="handleFileUpload"
												   accept=".json,.txt"
												   style="display: none" />
											<v-btn color="primary"
												   variant="flat"
												   prepend-icon="mdi-upload"
												   @click="$refs.fileInput.click()">
												Upload File
											</v-btn>
											<v-btn color="primary"
												   variant="flat"
												   prepend-icon="mdi-format-align-left"
												   @click="formatJson"
												   :disabled="!isValidJson(editItem.jsonConfig)">
												Format JSON
											</v-btn>
											<v-spacer></v-spacer>
											<v-btn variant="outlined" @click="closeEdit">
												Cancel
											</v-btn>
											<v-btn color="primary"
												   variant="flat"
												   @click="funSaveItemEdit()"
												   :loading="loadingEdit"
												   :disabled="!isValidJson(editItem.jsonConfig)">
												Save
											</v-btn>
										</v-card-actions>
									</div>
								</v-card>
							</v-dialog>
						</div>
					</template>
					<template v-slot:[`item.type`]="{ item }">
						<td>{{ formatProtocolType(item.type) }}</td>
					</template>
					<template v-slot:[`item.action`]="{ item }">
						<v-icon small @click="funEditItem(item)">mdi-pencil</v-icon>
						<v-icon small @click="funDeleteItem(item)">mdi-delete</v-icon>
					</template>
					<template v-slot:no-data>
						<span>No Data Available</span>
					</template>
				</v-data-table>
			</v-col>
		</v-row>
		<v-snackbar v-model="snackbar"
					:timeout="snackbarTimeout"
					color="success"
					rounded="pill">
			<div style="text-align: center">
				{{ snackbarMessage }}
			</div>
		</v-snackbar>
	</v-container>
</template>

<script>
	import { mapState, mapActions } from "vuex";
	import {
		CREATE_PROTOCOL,
		EDIT_PROTOCOL,
		REMOVE_PROTOCOL,
		REMOVE_PROTOCOLS,
	} from "@/store/_actiontypes";
	import SPDHHOST from "../../../App_Data/SPDHHOST.json";
	import JsonEditor from "./JsonEditor.vue";

	export default {
		components: {
			JsonEditor,
		},
		data: () => ({
			loading: false,
			loadingEdit: false,
			dialog: false,
			editDialog: false,
			menu: false,
			typeMsgParsed: false,
			selectedItems: [],
			editorHeight: "60vh",
			headers: [
				{ title: "Id", key: "id", align: " d-none" },
				{ title: "Name", key: "name" },
				{ title: "Type", key: "type" },
				{ title: "Actions", key: "action", sortable: false, width: 50 },
			],
			editItem: {
				id: 0,
				name: "",
				type: 0,
				typeName: "SPDH",
				jsonConfig: "",
			},
			defaultItem: {
				id: 0,
				name: "",
				type: 0,
				typeName: "SPDH",
				jsonConfig: JSON.stringify(SPDHHOST, null, 2),
			},
			snackbar: false,
			snackbarMessage: "",
			snackbarTimeout: 2000,
		}),

		computed: {
			...mapState({
				protocolslist: (state) => state.protocols.protocolslist,
			}),
			itemTitle() {
				return this.editItem.id === 0 ? "New Protocol" : "Edit Protocol";
			},
			shouldShowSelect() {
				return this.protocolslist.length >= 1;
			},
			elementTextColor() {
				return this.$vuetify.theme.global.name === "dark" ? "white" : "black";
			},
			elementBackgroundColor() {
				return this.$vuetify.theme.global.name === "dark" ? "#3d1924" : "#cfe4f2";
			},
		},

		watch: {
			dialog(val) {
				val || this.close();
			},
			editDialog(val) {
				val || this.closeEdit();
			},
			selectedItems(val) {
				this.selectedItems = val;
			},
		},
		methods: {
			...mapActions("protocols", [
				CREATE_PROTOCOL,
				EDIT_PROTOCOL,
				REMOVE_PROTOCOL,
				REMOVE_PROTOCOLS,
			]),

			funEditItem(item) {
				this.editItem = Object.assign({}, item);
				this.dialog = true;
				this.editItem.typeName = this.formatProtocolType(item.type);
				// Handle escaped newlines in JSON config
				if (this.editItem.jsonConfig && this.isValidJson(this.editItem.jsonConfig)) {
					let jsonString = this.editItem.jsonConfig;
					// Check if the JSON string contains escaped newlines
					if (typeof jsonString === 'string' && jsonString.includes('\\n')) {
						try {
							// Try to parse once to remove the escaping layer
							jsonString = JSON.parse(jsonString);
						} catch (e) {
							// If it fails, use as-is
						}
					}
					this.editItem.jsonConfig = JSON.stringify(
						JSON.parse(jsonString),
						null,
						2
					);
				}
			},

			funDeleteItem(item) {
				confirm("Are you sure you want to delete this item?") &&
					this.REMOVE_PROTOCOL({ id: item.id });
			},
			deleteSelection() {
				const ids = [];
				for (var val in this.selectedItems) {
					ids.push(this.selectedItems[val]);
				}
				if (
					confirm(
						`Are you sure you want to delete ${ids.length} selected item(s)?`
					)
				) {
					this.REMOVE_PROTOCOLS({ ids: ids });
					this.selectedItems = [];
				}
			},
			close() {
				this.dialog = false;
				this.editItem = Object.assign({}, this.defaultItem);
				this.typeMsgParsed = false;
			},

			closeEdit() {
				this.editDialog = false;
			},

			formatJson() {
				if (this.isValidJson(this.editItem.jsonConfig)) {
					const parsed = JSON.parse(this.editItem.jsonConfig);
					this.editItem.jsonConfig = this.formatJsonWithCompactArrays(parsed);
				}
			},

			formatJsonWithCompactArrays(obj, indent = 0) {
				const spaces = '  '.repeat(indent);
				const nextSpaces = '  '.repeat(indent + 1);

				if (Array.isArray(obj)) {
					// Check if array contains only primitives (no objects/arrays)
					const hasOnlyPrimitives = obj.every(item =>
						typeof item !== 'object' || item === null
					);

					if (hasOnlyPrimitives) {
						// Format array on one line
						return '[' + obj.map(item => JSON.stringify(item)).join(', ') + ']';
					} else {
						// Format array with each item on new line
						const items = obj.map(item =>
							nextSpaces + this.formatJsonWithCompactArrays(item, indent + 1)
						).join(',\n');
						return '[\n' + items + '\n' + spaces + ']';
					}
				} else if (obj !== null && typeof obj === 'object') {
					const keys = Object.keys(obj);
					if (keys.length === 0) return '{}';

					const items = keys.map(key => {
						const value = this.formatJsonWithCompactArrays(obj[key], indent + 1);
						return `${nextSpaces}"${key}": ${value}`;
					}).join(',\n');

					return '{\n' + items + '\n' + spaces + '}';
				} else {
					return JSON.stringify(obj);
				}
			},

			funSaveItem() {
				this.loading = true;
				var item = this.editItem;
				item.type = this.getProtocolTypeId(this.editItem.typeName);

				// Normalize JSON - parse and stringify to ensure proper formatting
				if (item.jsonConfig && this.isValidJson(item.jsonConfig)) {
					item.jsonConfig = JSON.stringify(JSON.parse(item.jsonConfig));
				}

				if (item.id == 0) {
					this.CREATE_PROTOCOL({
						item,
					})
						.then(() => {
							this.close();
						})
						.finally(() => {
							this.loading = false;
						});
				} else {
					this.EDIT_PROTOCOL({
						item,
					})
						.then(() => {
							this.close();
						})
						.finally(() => {
							this.loading = false;
						});
				}
			},

			funSaveItemEdit() {
				if (this.isValidJson(this.editItem.jsonConfig)) {
					this.loadingEdit = true;

					// Normalize JSON format - compact for storage
					this.editItem.jsonConfig = JSON.stringify(
						JSON.parse(this.editItem.jsonConfig)
					);

					this.editDialog = false;
					this.loadingEdit = false;
					this.snackbarMessage = "Type Message saved successfully";
					this.snackbar = true;
				} else {
					alert("INVALID JSON!");
				}
			},

			funEditMessage(item) {
				if (this.itemTitle === "New Protocol") {
					if (!this.editItem.jsonConfig) {
						this.editItem.jsonConfig = this.defaultItem.jsonConfig;
					} else if (this.isValidJson(this.editItem.jsonConfig)) {
						// Format existing JSON with compact arrays
						const parsed = JSON.parse(this.editItem.jsonConfig);
						this.editItem.jsonConfig = this.formatJsonWithCompactArrays(parsed);
					}
				} else if (!this.typeMsgParsed) {
					// Format JSON when opening edit dialog with compact arrays
					if (item && this.isValidJson(item)) {
						// Handle escaped newlines - convert them to actual newlines first
						let jsonString = item;
						if (typeof jsonString === 'string' && jsonString.includes('\\n')) {
							// This is a double-escaped JSON string, parse it twice
							try {
								jsonString = JSON.parse(jsonString);
							} catch (e) {
								// If first parse fails, it's already a valid JSON string
							}
						}
						const parsed = JSON.parse(jsonString);
						this.editItem.jsonConfig = this.formatJsonWithCompactArrays(parsed);
					} else {
						this.editItem.jsonConfig = item;
					}
					this.typeMsgParsed = true;
				}
				this.editDialog = true;
			},
			formatProtocolType(type) {
				var ret = type;
				var list = this.getProtocolType();
				if (ret < list.length) {
					return list[ret];
				}
				return ret;
			},
			getProtocolType() {
				return ["HPDH", "SPDH", "APACS", "ISOHEX", "ISO8583"];
			},
			getProtocolTypeId(type) {
				var list = this.getProtocolType();
				return list.indexOf(type);
			},
			isValidJson(json) {
				try {
					JSON.parse(json);
					return true;
				} catch (e) {
					return false;
				}
			},
			handleFileUpload(event) {
				this.editItem.jsonConfig = "";
				const file = event.target.files[0];
				if (file) {
					const fileName = file.name.toLowerCase();

					// Check if the file extension is valid
					if (fileName.endsWith(".txt") || fileName.endsWith(".json")) {
						const reader = new FileReader();
						reader.onload = () => {
							const content = reader.result;
							// Format JSON if valid with compact arrays
							if (this.isValidJson(content)) {
								let jsonString = content;
								// Handle escaped newlines
								if (typeof jsonString === 'string' && jsonString.includes('\\n')) {
									try {
										jsonString = JSON.parse(jsonString);
									} catch (e) {
										// Use as-is if parsing fails
									}
								}
								const parsed = JSON.parse(jsonString);
								this.editItem.jsonConfig = this.formatJsonWithCompactArrays(parsed);
							} else {
								this.editItem.jsonConfig = content;
							}
							event.target.value = ""; // Reset input field to allow multiple uploads
						};
						reader.readAsText(file);
					} else {
						alert("Invalid file type. Please select a .txt or .json file.");
						event.target.value = ""; // Reset input field in case of invalid file type
					}
				}
			},
		},
	};
</script>

<style>
	.element {
		padding: 10px;
		border: none;
		color: black;
	}

	.start {
		display: flex;
		justify-content: flex-start;
	}

	.end {
		display: flex;
		justify-content: flex-end;
		align-items: center;
	}

	.delete {
		cursor: pointer;
	}

	.button-container {
		position: sticky;
		bottom: 0;
		background: inherit;
		z-index: 1;
	}
</style>